import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import EmailIcon from '@mui/icons-material/Email';
import HelpIcon from '@mui/icons-material/Help';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import SecurityIcon from '@mui/icons-material/Security';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { sendContactForm } from '../services/api';

const faqs = [
  { question: 'Como puedo comprar una entrada?', answer: 'Busca el evento que te interese, haz clic en "Ver evento" y luego en "Comprar entradas". Rellena los datos de los asistentes y confirma la compra.' },
  { question: 'Donde encuentro mis entradas despues de comprar?', answer: 'Tus entradas estan disponibles en "Mis entradas" dentro de tu perfil. Tambien puedes acceder desde el menu lateral.' },
  { question: 'Como funciona el QR de la entrada?', answer: 'Cada entrada tiene un codigo QR unico. Muestralo en la entrada del evento para que el personal lo escanee y valide tu acceso.' },
  { question: 'Puedo comprar entradas sin registrarme?', answer: 'No, es necesario tener una cuenta para comprar entradas. El registro es gratuito y solo tarda unos segundos.' },
  { question: 'Puedo cambiar el nombre de una entrada?', answer: 'Proximamente habilitaremos esta opcion. Por ahora contacta con nosotros si necesitas hacer algun cambio.' },
  { question: 'Que pasa si pierdo mi entrada?', answer: 'No te preocupes, puedes acceder a tus entradas en cualquier momento desde "Mis entradas" en tu perfil.' },
  { question: 'Como puedo cancelar una compra?', answer: 'La politica de cancelacion depende de cada evento. Contacta con nosotros para gestionar cualquier incidencia.' },
];

function Contact() {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const [openFaq, setOpenFaq] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.subject || !form.message) {
      setError('Por favor rellena todos los campos.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await sendContactForm(form);
      setSent(true);
    } catch (err) {
      setError('Error al enviar el mensaje. Intentalo de nuevo o escribenos a info@galiticket.com');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ padding: isMobile ? '1rem' : '2rem', maxWidth: '900px', margin: '0 auto' }}>

        <h1 style={{ color: colors.text, fontSize: isMobile ? '1.4rem' : '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Ayuda y contacto</h1>
        <p style={{ color: colors.textSecondary, marginBottom: isMobile ? '1.5rem' : '3rem', fontSize: isMobile ? '0.9rem' : '1rem' }}>Estamos aqui para ayudarte con cualquier duda o problema.</p>

        {/* TARJETAS DE CONTACTO */}
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem', marginBottom: isMobile ? '1.5rem' : '3rem' }}>
          {[
            { icon: <EmailIcon style={{ color: colors.accent, fontSize: 28 }} />, title: 'Email', desc: 'Respuesta en menos de 24h', info: 'info@galiticket.com' },
            { icon: <ConfirmationNumberIcon style={{ color: colors.accent, fontSize: 28 }} />, title: 'Problema con tu entrada', desc: 'Accede a tus entradas desde', info: 'Mi perfil → Mis entradas' },
            { icon: <SecurityIcon style={{ color: colors.accent, fontSize: 28 }} />, title: 'Seguridad', desc: 'Reporta un problema de seguridad', info: 'seguridad@galiticket.com' },
          ].map((item, i) => (
            <div key={i} style={{ backgroundColor: colors.bgSecondary, borderRadius: '16px', border: `1px solid ${colors.border}`, padding: isMobile ? '1rem' : '1.5rem' }}>
              <div style={{ marginBottom: '1rem' }}>{item.icon}</div>
              <h3 style={{ color: colors.text, fontWeight: 'bold', marginBottom: '0.4rem' }}>{item.title}</h3>
              <p style={{ color: colors.textSecondary, fontSize: '0.85rem', marginBottom: '0.4rem' }}>{item.desc}</p>
              <p style={{ color: colors.accent, fontSize: '0.9rem', fontWeight: '500' }}>{item.info}</p>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '1.5rem' : '2rem' }}>

          {/* PREGUNTAS FRECUENTES */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.5rem' }}>
              <HelpIcon style={{ color: colors.accent, fontSize: 24 }} />
              <h2 style={{ color: colors.text, fontWeight: 'bold', fontSize: isMobile ? '1rem' : '1.2rem' }}>Preguntas frecuentes</h2>
            </div>
            {faqs.map((faq, index) => (
              <div key={index} style={{ backgroundColor: colors.bgSecondary, borderRadius: '12px', border: `1px solid ${colors.border}`, marginBottom: '0.8rem', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.2rem', cursor: 'pointer' }} onClick={() => setOpenFaq(openFaq === index ? null : index)}>
                  <span style={{ color: colors.text, fontSize: isMobile ? '0.85rem' : '0.9rem', fontWeight: '500', paddingRight: '1rem' }}>{faq.question}</span>
                  {openFaq === index ? <ExpandLessIcon style={{ color: colors.accent, flexShrink: 0 }} /> : <ExpandMoreIcon style={{ color: colors.textSecondary, flexShrink: 0 }} />}
                </div>
                {openFaq === index && (
                  <div style={{ padding: '0 1.2rem 1rem', borderTop: `1px solid ${colors.border}` }}>
                    <p style={{ color: colors.textSecondary, fontSize: '0.85rem', lineHeight: 1.6, paddingTop: '0.8rem' }}>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* FORMULARIO DE CONTACTO */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.5rem' }}>
              <EmailIcon style={{ color: colors.accent, fontSize: 24 }} />
              <h2 style={{ color: colors.text, fontWeight: 'bold', fontSize: isMobile ? '1rem' : '1.2rem' }}>Envianos un mensaje</h2>
            </div>
            <div style={{ backgroundColor: colors.bgSecondary, borderRadius: '16px', border: `1px solid ${colors.border}`, padding: isMobile ? '1rem' : '1.5rem' }}>
              {sent ? (
                <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                  <EmailIcon style={{ color: '#00cc66', fontSize: '3rem', marginBottom: '1rem' }} />
                  <h3 style={{ color: colors.text, fontWeight: 'bold', marginBottom: '0.5rem' }}>Mensaje enviado!</h3>
                  <p style={{ color: colors.textSecondary, fontSize: '0.9rem' }}>Te responderemos en menos de 24 horas.</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {[
                    { label: 'Nombre', name: 'name', type: 'text', placeholder: 'Tu nombre' },
                    { label: 'Email', name: 'email', type: 'email', placeholder: 'tu@email.com' },
                    { label: 'Asunto', name: 'subject', type: 'text', placeholder: 'En que podemos ayudarte?' },
                  ].map(field => (
                    <div key={field.name}>
                      <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>{field.label}</label>
                      <input
                        style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
                        name={field.name} type={field.type} placeholder={field.placeholder}
                        value={form[field.name]} onChange={handleChange}
                      />
                    </div>
                  ))}
                  <div>
                    <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Mensaje</label>
                    <textarea
                      style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box', resize: 'vertical', minHeight: '120px', fontFamily: 'inherit' }}
                      name="message" placeholder="Cuentanos tu problema o consulta..."
                      value={form.message} onChange={handleChange}
                    />
                  </div>
                  {error && (
                    <p style={{ color: '#ff4444', fontSize: '0.85rem', margin: 0 }}>{error}</p>
                  )}
                  <button
                    style={{ backgroundColor: loading ? colors.bgTertiary : colors.accent, color: loading ? colors.textSecondary : colors.accentText, border: 'none', padding: '0.9rem', borderRadius: '25px', cursor: loading ? 'default' : 'pointer', fontWeight: 'bold', fontSize: '1rem' }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? 'Enviando...' : 'Enviar mensaje'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;